import { render, staticRenderFns } from "./MileageNoticeForm.vue?vue&type=template&id=3983d150"
import script from "./MileageNoticeForm.vue?vue&type=script&lang=js"
export * from "./MileageNoticeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports